"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parseQuery_1 = require("./parseQuery");
/**
 * Return value for a query parameter current window location query string.
 * Examples:
 *  current url is: https://example.com?A=AValue&c=cvalue getQueryParam('A') will return 'AValue'
 *  current url is: https://example.com?c[]=cvalue1&A=AValue&c[]=cvalue2 getQueryParam('c') will return ['cvalue1', 'cvalue2']
 *
 * @returns the value for a query parameter with format key=value
 * @param key to access to query parameter value
 * @param fallback If key is not in query string, it will return fallback value
 * @param search Custom window location query string, e.g. of the parent window
 */
exports.getQueryParam = function (key, fallback, search) {
    if (fallback === void 0) { fallback = ''; }
    if (search === void 0) { search = ''; }
    var parsed = parseQuery_1.parseQuery(search || window.location.search);
    return parsed ? (parsed.hasOwnProperty(key) ? parsed[key] : fallback) : fallback;
};
//# sourceMappingURL=getQueryParam.js.map